module.exports = __webpack_public_path__ + "img/manufacturing-activity.27a6fdc9.jpg";